module.exports = __webpack_public_path__ + "static/img/jiang.c4688e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/jiang.png
// module id = 0/Y6
// module chunks = 1